// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"5016":"c3a71a48","5201":"b1d1cc8d","7665":"5b3a3581"}[chunkId] + ".chunk.css");